import { DetectorType, SecurityScanConclusionEnum } from '@repo/api-gw-sdk';

export const DETECTOR_OPTIONS = [
  {
    id: DetectorType.RansomwareBehavior,
    name: 'Ransomware',
    icon: 'material-symbols-skull-outline',
  },
  {
    id: DetectorType.Malware,
    name: 'Malware',
    icon: 'material-symbols-bug-report-outline-rounded',
  },
  {
    id: DetectorType.DataAnomaly,
    name: 'Anomalous activity',
    icon: 'material-symbols-line-axis',
  },
];

export const SECURITY_SCAN_CONCLUSION_OPTIONS = [
  {
    id: SecurityScanConclusionEnum.HighChanceForRansomware,
    name: 'Ransomware',
    icon: 'material-symbols-skull-outline',
  },
  {
    id: SecurityScanConclusionEnum.MalwareDetected,
    name: 'Malware',
    icon: 'material-symbols-bug-report-outline-rounded',
  },
  {
    id: SecurityScanConclusionEnum.DataAnomalyDetected,
    name: 'Anomalous activity',
    icon: 'material-symbols-line-axis',
  },
];
